import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledFlex } from '../../../styles/common';
import { StyledTitle } from '../../../styles/text';
import NoTransactionIllustration from '../illustrations/no-transaction';
var NoTransactions = function (_a) {
    var activeFilter = _a.activeFilter;
    var t = useTranslation().t;
    var defaultActiveFilter = activeFilter === 'all';
    var isMobile = useDeviceWidth();
    return (_jsx(Inset, { top: "large", bottom: "xxlarge", vertical: "large", children: _jsxs(StyledFlex, { direction: "column", alignItems: "center", children: [_jsx(NoTransactionIllustration, { width: isMobile ? 172 : 242, height: isMobile ? 150 : 197 }), _jsx(Stack, { size: isMobile ? 'large' : 'xlarge' }), _jsx(StyledTitle, { size: isMobile ? 'medium' : 'large', align: "center", children: t(defaultActiveFilter
                        ? 'activity.noTransactionsMessage'
                        : 'activity.noTransactionsMessageWithMonths') }), _jsx(Stack, { size: "xlarge" }), _jsx(Stack, { size: "xlarge" })] }) }));
};
export default NoTransactions;
//# sourceMappingURL=index.js.map